import { MerchantsApiBase } from './paymentApi';

class MerchantApi extends MerchantsApiBase {

}

export default new MerchantApi();
